import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../../redux/baseQuery";

interface SendTestBody {
  user: string;
}

interface SendTestResponse {
  data: { message?: string; success: boolean };
}

export const createUserConfigSendTestApi = createApi({
  reducerPath: "userConfigSendTestApi",
  baseQuery,
  endpoints: (builder) => ({
    sendWebhookTest: builder.mutation<SendTestResponse, SendTestBody>({
      query: (body) => ({
        url: "userconfig/test",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useSendWebhookTestMutation } = createUserConfigSendTestApi;
